import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getPublisherOptions } from '@/module/Publisher';
import { PublisherEdit } from '@/module/Publisher/PublisherEdit';

export const Route = createFileRoute('/_auth/publisher/_publisher/$publisherId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { publisherId } = Route.useParams();
  const { data: publisher } = useSuspenseQuery(getPublisherOptions(publisherId));

  return <PublisherEdit publisher={publisher} />;
}
